<template>
    <div class="text-center">
        <a class="resend-link" :disabled="hasOnGoingCountDown" @click="submit">
            <i v-if="loading !== true" class="fa fa-refresh" />
            <i v-if="loading === true" class="fa fa-spinner fa-spin" />

            {{ $t('registration.resend_mail') }}

            <span v-if="hasOnGoingCountDown">
                ({{ $t('registration.seconds', {seconds: countDown}) }})
            </span>
        </a>
    </div>
</template>

<script>
const defaultCountDown = 60;
let intervalTimer;

export default {
    data() {
        return {
            loading : false,
            countDownLaunched : false,
            countDown : defaultCountDown,
        };
    },
    computed: {
        hasOnGoingCountDown() {
            return this.countDownLaunched === true && this.countDown > 0;
        },
    },
    methods: {
        submit() {
            if (this.loading === true || this.countDownLaunched === true) {
                return;
            }

            this.loading = true;

            axios
                .post('/registration/resend-mail')
                .then(response => {
                    this.countDownLaunched = true;
                    clearInterval(intervalTimer);
                    this.timer(response.data.countDown || defaultCountDown);
                })
                .catch(response => {
                    this.countDownLaunched = true;
                    clearInterval(intervalTimer);
                    this.timer(response.response.data.countDown || defaultCountDown);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        setTime(seconds) {
            clearInterval(intervalTimer);
            this.timer(seconds);
        },
        timer(seconds) {
            this.displayTimeLeft(seconds);
            this.countdown(seconds);
        },
        countdown(seconds) {
            intervalTimer = setInterval(() => {
                seconds--;

                if(seconds < 0) {
                    this.countDownLaunched = false;
                    clearInterval(intervalTimer);
                    return;
                }
                this.displayTimeLeft(seconds);
            }, 1000);
        },
        displayTimeLeft(seconds) {
            this.countDown = seconds;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/registration/ResendEmailUserCreateComponent.vue